// TODO
// Clear flag send WP token to server till backlog 2 issues:
// 1. When user change from Allow -> Ask ( default ) gettoken method will send pending instead of throw error hence can not clear flag
// 2. When user unsubcribe SW in console -> Application -> Service Workers

import { generateSpinGame } from './Components/SpinGame'
import { generateDefaultCode } from './Components/DefaultCode'
import { generateRandomGift } from './Components/RandomGift'
import addDependencies from './Functions/addDependencies'
import sendTrackingData from './Functions/sendTrackingData'

import './Assets/index.css'
import { fetchMiniGameData, fetchPopup } from './Services'
import { sleep } from './Utils'
import { getTrackingId } from './Utils'
import { countViewTime } from './Functions/shouldShowPopup'

import {
  ACTION_MANAGER_KEY,
  EXIT_INTENT_SESSION_UUID,
  PAGE_DEACTIVATED_EVENT_SENT_KEY,
  PAGE_DEACTIVATED_KEY,
  POPUP_KEY,
  SEND_TOKEN_SESSION_UUID,
  WELCOME_PUSH_DATA_KEY,
  SUBSCRIBE_TRACKING_CODE,
  EXIT_INTENT_TRACKING_CODE,
  POPUP_TRACKING_CODE,
  POPUP_ENRICH_DATA_TRACKING_CODE,
  TOAST_TRACKING_CODE,
  COOKIE_DEFAULT_KEY,
  WELCOME_PUSH_EXPIRED_DAYS,
  MODAL_TIMEOUT,
  TOAST_SHOW_TIME,
  TOAST_HIDE_TIME,
  WELCOME_PUSH_MASSAGE_TIMEOUT,
  CHECK_PAGE_DEACTIVATED_TIMEOUT,
  SHOW_MINIGAME_TIMEOUT,
  MOBILE_PRE_DEFINED,
  DESKTOP_PRE_DEFINED,
  DEFAULT_SPIN_GAME_DATA,
  POPUP_TEST,
  TIME_SHOW_POPUP,
} from './Constants'

// ===== KARIBA NAMSPACE ====
const Kariba = function (custom = {}) {
  // API
  const WELCOME_PUSH_MASSAGE_URL = `${process.env.API_HOST}/action-triggers/public/welcome_push?channel=toast`

  // TIMEOUT ID
  let TOAST_TIMEOUT_IDS = {}

  // // ! GiayDepMienTay webpush config
  // const WP_CONFIG = {
  //   vapidKey:
  //     "BKAPhH4885oIbsZuL1MJOIaXiFDsC1Bj0sXVLtvb9xxhGdaQkeooGBJagxmlENtyg11W-5E9MO-WrnaJ4HjhBTE",
  //   firebaseConfig: {
  //     apiKey: "AIzaSyD0G1hQlJVLqjwEGOLqpqjkb0UAqZmY0ew",
  //     authDomain: "giaydep-mientay.firebaseapp.com",
  //     projectId: "giaydep-mientay",
  //     storageBucket: "giaydep-mientay.appspot.com",
  //     messagingSenderId: "661016963585",
  //     appId: "1:661016963585:web:0230ddf379f1f2630b2e00",
  //     measurementId: "G-1PJBB5BK02",
  //   },
  //   swRegisterUrl:
  //     "https://staging-juno-recommender.hoian.ai/firebase-messaging-sw.js",
  // };
  // // ! Juno Staging webpush config
  // const WP_CONFIG = {
  //   vapidKey:
  //     'BMyPyP4Jf8eRwb7BXdJybUseX6J917ira7a2EPnawa-i6Ln23GDPlnd2sfb8Yegob3hQrvk9bMEWZ-OJ9SDFHg0',
  //   firebaseConfig: {
  //     apiKey: 'AIzaSyBS_6WyTh9YUaGuvodvCen11U3Lgt68PWI',
  //     authDomain: 'kariba-staging-juno.firebaseapp.com',
  //     projectId: 'kariba-staging-juno',
  //     storageBucket: 'kariba-staging-juno.appspot.com',
  //     messagingSenderId: '502807836099',
  //     appId: '1:502807836099:web:64b6f5e637ea423936b976',
  //     measurementId: 'G-WRSQSW2ZB6',
  //   },
  //   swRegisterUrl: 'https://juno-2.myharavan.com/apps/hrvsw/firebase-messaging-sw.js',
  // }
  // // ! Kariba Production webpush config
  const WP_CONFIG = {
    vapidKey:
      'BEJ74vEMyGt-upirbJPgoBa3rqgUcT_jibxJtgt8F3qss4s-LdH2UcgqUK19KgNbKD_ypY9yFWwzTp2nz-IzMBM',
    firebaseConfig: {
      apiKey: 'AIzaSyD3W9wCis2pqWAxVlFgyC73CI8_M3nsivQ',
      authDomain: 'kariba-juno-147b1.firebaseapp.com',
      projectId: 'kariba-juno-147b1',
      storageBucket: 'kariba-juno-147b1.appspot.com',
      messagingSenderId: '725492603698',
      appId: '1:725492603698:web:9698add9fc0f21c107552b',
      measurementId: 'G-8BNNZGRS1H',
    },
    swRegisterUrl: 'https://juno.vn/apps/hrvsw/kariba-sdk.js',
  }
  const KARIBA_DEPENDENCIES = [
    {
      url: 'https://storage.googleapis.com/kariba-public/juno/winwheel/Winwheel.min.js',
      type: 'script',
    },
    {
      url: 'http://cdnjs.cloudflare.com/ajax/libs/gsap/latest/TweenMax.min.js',
      type: 'script',
    },
    {
      url: 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit',
      type: 'script',
    },
  ]

  let __DEV__ = false
  let instance
  let scroll
  let isMobile = mobileDetecting()
  let isMac = macDetecting()
  let options = isMobile ? MOBILE_PRE_DEFINED : DESKTOP_PRE_DEFINED
  let level = custom.level || 'medium'

  function macDetecting() {
    return navigator.platform.indexOf('Mac') > -1
  }

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  function generateSessionId() {
    return generateUUID()
  }

  function getSessionId(key = EXIT_INTENT_SESSION_UUID) {
    return sessionStorage.getItem(key)
  }
  function setSessionId(key = EXIT_INTENT_SESSION_UUID) {
    sessionStorage.setItem(key, generateSessionId())
  }

  function isSessionDisabled(key, value = 'true') {
    return sessionStorage.getItem(key) === value
  }

  function disableSession(key, value = true) {
    return sessionStorage.setItem(key, value)
  }

  function parseCookies() {
    // cookies are separated by '; '
    let cookies = document.cookie.split('; ')

    let ret = {}
    for (let i = cookies.length - 1; i >= 0; i--) {
      let el = cookies[i].split('=')
      ret[el[0]] = el[1]
    }
    return ret
  }

  const setExpiredTime = (days = 1) => {
    // transform days to milliseconds
    let ms = days * 24 * 60 * 60 * 1000
    let date = new Date()
    date.setTime(date.getTime() + ms)
    return '; expires=' + date.toUTCString()
  }

  function disable(name, days = 30) {
    let cookieExpire = setExpiredTime(days)
    let cookieName = name || COOKIE_DEFAULT_KEY
    document.cookie = cookieName + '=true' + cookieExpire
  }

  function isDisabled(name) {
    if (__DEV__) return false
    let cookieName = name || COOKIE_DEFAULT_KEY
    return checkCookieValue(cookieName, 'true')
  }

  const checkCookieValue = function (COOKIE_DEFAULT_KEY, value) {
    return parseCookies()[COOKIE_DEFAULT_KEY] === value
  }

  const trackingExitIntent = function (behavior_name = '') {
    sendTrackingData(EXIT_INTENT_TRACKING_CODE, behavior_name)
  }

  const getWelcomePushContent = function () {
    fetch(WELCOME_PUSH_MASSAGE_URL).then(function (resp) {
      resp.json().then((data) => {
        if (!data.value) return
        sessionStorage.setItem(WELCOME_PUSH_DATA_KEY, data.value.htmlTemplate)
      })
    })
  }

  async function load_scripts(script_urls) {
    function load(script_url) {
      return new Promise(function (resolve, reject) {
        if (load_scripts.loaded.has(script_url)) {
          resolve()
        } else {
          var script = document.createElement('script')
          script.onload = resolve
          script.src = script_url
          document.head.appendChild(script)
        }
      })
    }
    var promises = []
    for (const script_url of script_urls) {
      promises.push(load(script_url))
    }
    await Promise.all(promises)
    for (const script_url of script_urls) {
      load_scripts.loaded.add(script_url)
    }
  }

  const initFirebase = () => {
    load_scripts.loaded = new Set()
    load_scripts(['https://www.gstatic.com/firebasejs/8.2.1/firebase-app.js']).then(
      load_scripts(['https://www.gstatic.com/firebasejs/8.2.1/firebase-messaging.js']).then(() => {
        try {
          firebase.initializeApp(WP_CONFIG.firebaseConfig)
          getFirebaseToken()
        } catch (err) {
          console.log('load_scripts firebase Error: ', err)
        }
      })
    )
  }

  const sendTokenToServer = (currentToken) => {
    if (isSessionDisabled(SEND_TOKEN_SESSION_UUID)) return
    disableSession(SEND_TOKEN_SESSION_UUID)
    hoian.signal(SUBSCRIBE_TRACKING_CODE, [{ bs_token: currentToken }])
  }

  const getFirebaseToken = async () => {
    if ('serviceWorker' in navigator) {
      // This tells the browser where your service worker JavaScript file lives.
      navigator.serviceWorker
        .register(WP_CONFIG.swRegisterUrl)
        .then(async (registration) => {
          const messaging = firebase.messaging()
          messaging.onMessage(function (event) {
            const payload = event.notification
            registration.showNotification(payload.title ? payload.title : '', payload)
          })
          const token = await messaging.getToken({
            serviceWorkerRegistration: registration,
            vapidKey: WP_CONFIG.vapidKey,
          })
          sendTokenToServer(token)
        })
        .catch((error) => {
          disableSession(SEND_TOKEN_SESSION_UUID, false)
          console.log('Get Firebase token failed: ', error)
        })
    }
  }

  const requestNotiPerm = async () => {
    if (isDisabled('welcome_push')) return
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      disable('welcome_push', WELCOME_PUSH_EXPIRED_DAYS)
      showToast({
        timeout: WELCOME_PUSH_MASSAGE_TIMEOUT,
        contentHtml: sessionStorage.getItem(WELCOME_PUSH_DATA_KEY),
      })
    }
  }

  function _karibaToastOnClick(toastId) {
    clearTimeout(TOAST_TIMEOUT_IDS[toastId])
    const toastEle = document.querySelector(`[kariba_toast_uuid="${toastId}"]`)
    toastEle.className = toastEle.className.replace('show', '')
  }

  // ======= Toast ========
  const showToast = function (options = {}) {
    let toastId = generateUUID()
    let showTime = options.timeout || TOAST_SHOW_TIME
    let hideTime = options.duration || TOAST_HIDE_TIME
    let contentHtml = options.contentHtml
    if (!contentHtml) return
    let html = `<div 
                  id="kariba_toast" 
                  kariba_toast_uuid=${toastId} 
                  onclick="window._karibaToastOnClick('${toastId}')">
                    <span class="close-btn" 
                      style="position: absolute;
                      z-index: 19091991;
                      top: -5px;
                      right: -5px;
                      background: red;
                      border-radius: 50%;
                      width: 20px;
                      height: 20px;
                      color: #333333;
                      background-color: #ffffff;
                      display: flex;
                      font-size: 11px;
                      font-weight: bold;
                      justify-content: center;
                      align-items: center;
                      border: 1px solid #eeeeee;
                      cursor: pointer;"
                    >&#x2715</span>
                    ${contentHtml}
                </div>`
    let toastElement = document.getElementById('kariba_toast')
    if (!toastElement) document.body.innerHTML = document.body.innerHTML + html
    toastElement = document.getElementById('kariba_toast')
    setTimeout(function () {
      toastElement.className = isMac ? 'show' : 'bottom-right show'
    }, showTime)
    TOAST_TIMEOUT_IDS[toastId] = setTimeout(function () {
      toastElement.className = toastElement.className.replace('show', '')
    }, showTime + hideTime)
  }

  // ======= Modal ========
  const showModal = function (options = {}) {
    let contentHtml = options.contentHtml || 'No HTML'
    let timeout = options.timeout || MODAL_TIMEOUT

    // Default template of the Modal
    // Todo: should replace here and make placeholder to get content from BE

    let html = `<div id="Kariba_Popup" class="kariba-modal">\
                  <div class="kariba-modal-content" >
                    <span class="close-icon">&times;</span>\
                    ${contentHtml}
                  </div>
                </div>`
    let modalElement = document.getElementById('Kariba_Popup')
    if (!modalElement) document.body.innerHTML = document.body.innerHTML + html
    modalElement = document.getElementById('Kariba_Popup')
    // Get the <span> element that closes the Modal
    let spanElement = document.querySelector('#Kariba_Popup .close-icon')
    // When the user clicks on <span> (x), close the Modal
    spanElement.onclick = function () {
      // modalElement.style.display = 'none'
      modalElement.style.setProperty('display', 'none', 'important')
    }
    // When the user clicks anywhere outside of the Modal, close it
    window.onclick = function (event) {
      if (event.target == modalElement) {
        // modalElement.style.display = 'none'
        modalElement.style.setProperty('display', 'none', 'important')
      }
    }
    // Show Modal when function was triggered
    setTimeout(function () {
      modalElement.style.display = 'block'
    }, timeout || 2000)
  }

  // ===== Detect Mobile or Desktop =====
  function mobileDetecting() {
    document.addEventListener('touchstart', function () {
      document.body.classList.add('mobile-detected')
    })
    return document.getElementsByTagName('body')[0].classList.contains('mobile-detected')
  }

  function scrolling(resp) {
    let sensibility = options[level].scrolling.sensibility
    let comparator = options[level].scrolling.comparator

    function scrollSpeed() {
      if (isSessionDisabled(getSessionId())) return
      scroll = getScrollDelta()
      console.log('scrollSpeed', scroll)
      // Mobile track
      if (isMobile && comparator === '<' && scroll < sensibility) {
        showPopup({ contentHtml: resp.htmlTemplate, timeout: 1500 }, 'fast_scroll')
        trackingExitIntent('fast_scroll')
        disableSession(getSessionId())
      } else if (comparator === '>' && scroll > sensibility) {
        // Desktop track
        trackingExitIntent('fast_scroll')
        showPopup({ contentHtml: resp.htmlTemplate, timeout: 1500 }, 'fast_scroll')
        disableSession(getSessionId())
      }
    }

    let getScrollDelta = (function () {
      //Function that checks the speed of scrolling
      let last_position,
        new_position,
        timer,
        delta,
        delay = 50
      function clear() {
        last_position = null
        delta = 0
      }

      clear()
      return function () {
        new_position = window.scrollY
        if (last_position != null) {
          delta = new_position - last_position
        }
        last_position = new_position
        clearTimeout(timer)
        timer = setTimeout(clear, delay)
        return delta
      }
    })()
    window.addEventListener('scroll', scrollSpeed)
  }

  const _onBeforeUnload = function () {
    showPopup()
    trackingExitIntent('unload_page')
    return 'Are you sure'
  }

  function reloadPage(options = {}) {
    window.onbeforeunload = _onBeforeUnload
  }

  function closeTab(options = {}) {
    reloadPage(options)
  }
  const _onPageDeactivated = function (resp) {
    if (isSessionDisabled(getSessionId())) return
    disableSession(getSessionId())
    sessionStorage.setItem(PAGE_DEACTIVATED_EVENT_SENT_KEY, 'true')
    showPopup({ contentHtml: resp.htmlTemplate, timeout: 10 }, 'change_tab')
    trackingExitIntent('change_tab')
  }

  function changeTab(resp) {
    setInterval(function () {
      sessionStorage.setItem(PAGE_DEACTIVATED_KEY, document.hidden)
      const isPageDeactivate = sessionStorage.getItem(PAGE_DEACTIVATED_KEY)
      const pageDeactivatedEventSent = sessionStorage.getItem(PAGE_DEACTIVATED_EVENT_SENT_KEY)
      if (isPageDeactivate === 'true' && pageDeactivatedEventSent === 'false')
        _onPageDeactivated(resp)
    }, CHECK_PAGE_DEACTIVATED_TIMEOUT)
  }

  const _onMouseLeave = function (e, resp) {
    let callback = options[level].mouseOutViewPort.callback || showModal
    let sensibility = options.sensibility || 10
    // Make sure mouse move top of Window
    if (e.clientY > sensibility) return
    if (isSessionDisabled(getSessionId())) return
    disableSession(getSessionId())
    showPopup({ contentHtml: resp.htmlTemplate }, 'mouse_leave')
    trackingExitIntent('mouse_leave')
  }

  function mouseOutViewPort(resp) {
    document.documentElement.addEventListener('mouseleave', (e) => _onMouseLeave(e, resp))
  }

  // TODO
  const deletePopupData = () => {}

  function getActionKey(action) {
    switch (action) {
      case 'popup':
        return POPUP_KEY
      default:
        return ''
    }
  }

  function disableNode(key) {
    try {
      let manager = JSON.parse(sessionStorage.getItem(ACTION_MANAGER_KEY))
      if (!manager) return
      let index = manager.findIndex((d) => d.key === key)
      manager[index].viewed = true
      sessionStorage.setItem(ACTION_MANAGER_KEY, JSON.stringify(manager))
    } catch (error) {
      return false
    }
  }

  function getFirstAvailableAction(actionType) {
    try {
      let manager = JSON.parse(sessionStorage.getItem(ACTION_MANAGER_KEY))
      if (!(manager instanceof Array)) return
      let action = manager.find((d) => d.actionType === actionType && !d.viewed)
      if (!action) return
      return action['key']
    } catch (error) {
      console.error(error)
      return false
    }
  }

  function showPopup(opts = {}, actionKey) {
    // let actionKey = getFirstAvailableAction(POPUP_KEY)
    if (!actionKey) return
    // let modalContent = sessionStorage.getItem(actionKey)
    // // Prevent show popup when content is null
    // if (modalContent)
    showModal(Object.assign(opts))
    disableNode(actionKey)
    sendTrackingData(POPUP_TRACKING_CODE, actionKey)
    localStorage.setItem('TimeReceivedPopup', Date.now())
  }

  function exitIntentCustomize(resp) {
    // const URL_TEST =
    //   'https://juno.vn/collections/san-pham-moi-nhat?itm_source=homepage&itm_medium=menu&itm_campaign=normal&itm_content=newin'
    // console.log('--------> ', URL_TEST?.split('/')[4]?.split('?')[0])
    // if (window.location.pathname.split('/')[4].split('?')[0] != 'sale-online') {
    // const getSlug = window.location.pathname?.split('/')[4]?.split('?')[0]
    const getIsVisitedSalePage = sessionStorage.getItem('isVisitSalePage')
    // console.log('--------> getIsVisitedSalePage  ', getIsVisitedSalePage)
    if (parseInt(getIsVisitedSalePage)) return
    if (isMobile) {
      // =========MOBIE========
      scrolling(resp)
    } else {
      // ========DESKTOP=======
      scrolling(resp)
      mouseOutViewPort(resp)
    }
    // =====MOBILE & DESKTOP=====
    // Todo Should change event, coz current event will trigger show alert
    // reloadPage();
    // closeTab();
    changeTab(resp)
  }

  const generatePopup = async () => {
    const preventingPages = [
      'he-thong-cua-hang',
      'flash-sale-quan-ao',
      'flash-sale-quan-ao-40',
      'flash-sale-quan-ao-30',
    ]
    const resp = await fetchMiniGameData()
    const respPopup = await fetchPopup()
    // const respPopup = POPUP_TEST
    const getSlug = window.location.pathname.split('/')[2]
    if (preventingPages.includes(getSlug)) return
    if (resp) {
      const getIdCJ = localStorage.getItem('CUSTOMER_JOURNEY_ID')
      const timeReceivedPopup = parseInt(localStorage.getItem('TimeReceivedPopup'))
      const idCj = resp.customer_journey_id

      if (getIdCJ == idCj) {
        if (timeReceivedPopup && Date.now() < timeReceivedPopup + TIME_SHOW_POPUP) return
        switch (resp?.popupType) {
          case 'default_code':
            generateDefaultCode(resp)
            break
          case 'random_gift':
            generateRandomGift(resp)
            break
          case 'spin_game':
            generateSpinGame(resp)
            break
        }
      } else {
        localStorage.setItem('CUSTOMER_JOURNEY_ID', idCj)
        switch (resp?.popupType) {
          case 'default_code':
            generateDefaultCode(resp)
            break
          case 'random_gift':
            generateRandomGift(resp)
            break
          case 'spin_game':
            generateSpinGame(resp)
            break
        }
      }
    }

    if (respPopup) {
      const getIdCJ = localStorage.getItem('CUSTOMER_JOURNEY_ID')
      const timeReceivedPopup = parseInt(localStorage.getItem('TimeReceivedPopup'))
      const idCj = respPopup.customer_journey_id
      if (getIdCJ == idCj) {
        if (timeReceivedPopup && Date.now() < timeReceivedPopup + TIME_SHOW_POPUP) return
        exitIntentCustomize(respPopup)
      } else {
        localStorage.setItem('CUSTOMER_JOURNEY_ID', idCj)
        exitIntentCustomize(respPopup)
      }
    }
  }

  function Singleton() {
    addDependencies()
    // initActionData()
    getWelcomePushContent()
    generatePopup()
    window._karibaToastOnClick = _karibaToastOnClick
    window.onload = function () {
      // console.log('onload --<>--')
      // const get2Products = sessionStorage.getItem(`countViewProductsPage`)
      // const urlTest = `/products/aaaa${get2Products}`
      // console.log('window.location.pathname ', window.location.pathname)
      // console.log(
      //   'window.location.pathname.split("/")[2] ',
      //   window.location.pathname?.split('/')[2]
      // )

      // const timeLogPage = sessionStorage.getItem('timeLogPage')
      // const isVisitSalePage = sessionStorage.getItem('isVisitSalePage')
      // if (!isVisitSalePage) {
      //   const getSlug = window.location.pathname?.split('/')[2]
      //   if (getSlug && getSlug == 'flash-sale-quan-ao') {
      //     sessionStorage.setItem('isVisitSalePage', 1)
      //   }
      // }

      // if (!timeLogPage) {
      //   sessionStorage.setItem('timeLogPage', Date.now())
      // }

      // if (window.location.pathname.split('/')[1] == 'products') {
      //   // if (urlTest.split('/')[1] == 'products') {
      //   countViewTime(window.location.pathname)
      //   // countViewTime(urlTest)

      //   const timeLogPageProduct = sessionStorage.getItem(`timeLogPageProduct`)
      //   // !timeLogPageProduct &&
      //   //   sessionStorage.setItem(`timeLogPageProduct-${getTrackingId()}`, Date.now())
      //   if (!timeLogPageProduct) {
      //     sessionStorage.setItem(`timeLogPageProduct`, Date.now())
      //     var today = new Date()
      //     var time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      //     sessionStorage.setItem(`timeLogPageProductFormat`, time)

      //     // console.log(sessionStorage.getItem(`timeLogPageProductFormat}`))
      //     // console.log(sessionStorage.getItem(`timeLogPageProduct`))
      //   }
      // }

      initFirebase()
      if (!getSessionId()) setSessionId()
      requestNotiPerm()
      sessionStorage.setItem(PAGE_DEACTIVATED_EVENT_SENT_KEY, false)
    }

    // if (isMobile) {
    //   // =========MOBIE========
    //   scrolling()
    // } else {
    //   // ========DESKTOP=======
    //   scrolling()
    //   mouseOutViewPort()
    // }
    // // =====MOBILE & DESKTOP=====
    // // Todo Should change event, coz current event will trigger show alert
    // // reloadPage();
    // // closeTab();
    // changeTab()

    return {
      isMobile,
      showModal,
      showToast,
      requestNotiPerm,
      initFirebase,
      getWelcomePushContent,
      // fetchActionData,
      showPopup,
      generateSessionId,
      getSessionId,
      isDisabled,
    }
  }
  if (instance === undefined) {
    instance = new Singleton()
    instance.__DEV__ = false
    delete instance.constructor
  }
  return instance
}
if (typeof window !== undefined) window.Kariba = Kariba

// https://storage.googleapis.com/dreamf-mcm-public-storage/js/juno/staging/kariba.minify.js?v="+(new Date).getTime()
